import {createSlice, createAsyncThunk, current} from "@reduxjs/toolkit";

const initialState = {
    isRightToLeft: false
};

const appearanceSlice = createSlice({
    name: "appearance",
    initialState: initialState,
    reducers:{
       setAppearance: (state, action) =>  ({...state, isRightToLeft: action.payload.isRightToLeft}),//no payload
    }
});

export default appearanceSlice.reducer;

export const { setAppearance } = appearanceSlice.actions;

